var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flushing-detail-template',{attrs:{"gender":_vm.gender,"hot-flushes":_vm.hotFlushes,"flush-locations":_vm.flushLocations,"flushes-duration":_vm.flushesDuration,"other-flush-locations":_vm.otherFlushLocations,"field-errors":_vm.fieldErrors,"show-menopause-question":_vm.showMenopauseQuestion},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }